
import { generateOpenAIWorksheet } from './openAIWorksheetService';

interface WorksheetGenerationRequest {
  type: 'puzzle' | 'matching' | 'sorting';
  grade: string;
  subject: string;
  difficulty: 'easy' | 'medium' | 'hard';
}

interface WorksheetContent {
  type: string;
  title: string;
  instructions: string;
  items: any[];
  theme?: string;
  totalItems?: number;
  generatedAt?: string;
  aiGenerated?: boolean;
}

interface GeneratedWorksheet {
  content: WorksheetContent;
  metadata: {
    estimatedTime: number;
    skillsTargeted: string[];
  };
}

export const generateWorksheet = async (request: WorksheetGenerationRequest): Promise<GeneratedWorksheet> => {
  console.log('🎯 Generating AI-powered worksheet for Grade', request.grade, request.subject, request.type);
  
  try {
    // Always use OpenAI generation for truly dynamic content
    const result = await generateOpenAIWorksheet(request);
    
    console.log('✅ Successfully generated AI worksheet:', {
      type: request.type,
      grade: request.grade,
      subject: request.subject,
      itemCount: result.content.totalItems,
      aiGenerated: result.content.aiGenerated,
      generatedAt: result.content.generatedAt
    });
    
    return result;
  } catch (error) {
    console.error('❌ AI worksheet generation failed:', error);
    throw new Error('Failed to generate AI worksheet. Please check your internet connection and try again.');
  }
};
